export default customElements.define('w-projection-recipe-card', class RecipeCard extends wealthify.CustomElementBaseClass {

    constructor() {
        const selector = 'c-projection-recipe-card';
        const config = {
            styleSelector: selector,
            templateHTML: `
            <div class="${selector}__container" data-root>
                <div class="${selector}__title-container">
                    <span class="${selector}__title" data-title></span>
                    <span class="${selector}__title-suffix" data-titlesuffix></span>
                </div>
                <div class="${selector}__content-container">
                <div class="${selector}__content" data-content>
                    <w-loading-spinner class="${selector}__loading-spinner" absolute="true" colour="black" data-loadingspinner></w-loading-spinner>
                        <div class="${selector}__projection u-margin__bottom-mobile--layout-xs" data-projection>
                            <w-datalist class="u-margin__bottom-mobile--layout-xs" collapsemobile="true" data-datalist></w-datalist>
                            <w-gauge-bar titleprop="This could give you of your desired retirement income" data-gauge></w-gauge-bar>
                        </div>
                    </div>
                    <w-button label="A label" fullwidth="true" iconright="caret-forward" data-submitbutton></w-button>
                    <w-button label="A label" fullwidth="true" iconright="caret-forward" type="secondary" data-undobutton></w-button>
                </div>
            </div>`,
            hasChildren: true,
            cacheDom: ['data-content', 'data-datalist', 'data-loadingspinner', 'data-gauge', 'data-projection', 'data-submitbutton', 'data-title', 'data-titlesuffix', 'data-undobutton',]
        };

        super(config);
        
        this.currentProjectionData = {
            'annualincome': 0,
            'monthlyincome': 0,
            'totalinvestment': 0,
            'totalprojection': 0,
        };

        this.open = true;

        this.onConnectedCallback = () => {
            this.classList.add(`${this.styleSelector}`);
            this._updateButtons();
            this._showgauge();

            this.transitionDuration = parseFloat(getComputedStyle(this.dom.root).transitionDuration) * 1000;
            this.transitionEasing = getComputedStyle(this.dom.root).transitionTimingFunction;
        };
    }

    static get projectionRequiredProps () {
        return ['annualincome', 'monthlyincome', 'totalinvestment', 'totalprojection'];
    }

    static get validTypes () {
        return ['pensionprojection'];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('annualtarget', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),

            new wealthify.Prop('initialprojectiondata'),

            new wealthify.Prop('loading', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),

            new wealthify.Prop('newprojectiondata', {
                default: {
                    'annualincome': 0,
                    'monthlyincome': 0,
                    'totalinvestment': 0,
                    'totalprojection': 0,
                },
                type: wealthify.propTypes.Object(),
                validators: [wealthify.propValidators.ObjectContainsKeys(this.projectionRequiredProps)]
            }),

            new wealthify.Prop('showgauge', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),

            new wealthify.Prop('submitbuttonlabel', {required: true}),

            new wealthify.Prop('submitbuttononclick'),

            new wealthify.Prop('titleprop', {required: true}),

            new wealthify.Prop('titlesuffix'),

            new wealthify.Prop('type', {
                default: 'pensionprojection',
                type: wealthify.propTypes.ArrayItem(this.validTypes)
            }),

            new wealthify.Prop('undobuttonlabel', {required: true}),

            new wealthify.Prop('undobuttononclick'),

            new wealthify.Prop('opencard', { type: wealthify.propTypes.Boolean() })
        ];
    }

    get propCallbacks () {
        return {
            annualtarget: (value) => {
                this.dom.gauge.max = value;
                this._updateGauge();
            },

            initialprojectiondata: (value) => this.currentProjectionData = value,

            loading: (loading) => {
                this.dom.submitbutton.disabledprop = loading;
                this.dom.undobutton.disabledprop = loading;

                const spinnerClassListAction = loading ? 'remove' : 'add';
                const contentClassListAction = loading ? 'add' : 'remove';

                this.dom.loadingspinner.classList[spinnerClassListAction]('u-display__none');
                this.dom.projection.classList[contentClassListAction](`${this.styleSelector}--hidden`);
            },

            newprojectiondata: (value) => this._updateDatalists(value),

            showgauge: () => {
                this._showgauge();
            },

            submitbuttonlabel: (value) => this.dom.submitbutton.label = value,

            submitbuttononclick: () => {
                this.dom.submitbutton.onclickprop = function () {
                    this.submitbuttononclick();
                    this._updateState();
                }.bind(this);
            },

            titleprop: (value) => this.dom.title.innerHTML = value,

            titlesuffix: (value) => this.dom.titlesuffix.innerHTML = value,

            type: () => {},

            undobuttonlabel: (value) => this.dom.undobutton.label = value,

            undobuttononclick: () => {
                this.dom.undobutton.onclickprop = function () {
                    this.undobuttononclick();
                    this._updateState();
                }.bind(this);
            },

            opencard: () => {
                if (this.opencard) {
                    this.open = !this.opencard;
                    this._updateState();
                }
            }
        };
    }

    _updateDatalists(data) {
        const heatmapData = this.__calculateHeatmap(data);

        this.dom.datalist.items = [{
            'separator': true,
            'label': 'Total investment',
            'value': `${wealthify.type.number.toCurrency(data['totalinvestment'], false)}`,
            'tertiary': `${heatmapData['totalinvestment']}`
        },
        {
            'separator': true,
            'label': 'Total Projected Value',
            'value': `${wealthify.type.number.toCurrency(data['totalprojection'], false)}`,
            'tertiary': `${heatmapData['totalprojection']}`
        },
        {
            'label': `${this.type === 'pensionprojection' ? 'YOUR PROJECTED VALUE AT RETIREMENT' : 'YOUR PROJECTED INCOMES'}`,
            'heading': true
        },
        {
            'separator': true,
            'label': 'Monthly Income Value',
            'value': `${wealthify.type.number.toCurrency(data['monthlyincome'], false)}`,
            'tertiary': `${heatmapData['monthlyincome']}`
        },
        {
            'separator': true,
            'label': 'Annual Income Value',
            'value': `${wealthify.type.number.toCurrency(data['annualincome'], false)}`,
            'tertiary': `${heatmapData['annualincome']}`
        }];

        this.currentProjectionData = data;
        this._updateGauge();
    }

    __calculateHeatmap(data) {
        let heatmapData = {};

        Object.keys(data).forEach((key) => {
            let heatmapValue = '';

            if (data[key] > this.currentProjectionData[key]) {
                heatmapValue = `<span class="${this.styleSelector}__heatmap ${this.styleSelector}__heatmap--increase"><w-icon type="caret-up-filled"></w-icon> ${wealthify.type.number.toCurrency(data[key] - this.currentProjectionData[key], false)}</span>`;
            } else if (data[key] < this.currentProjectionData[key]) {
                heatmapValue = `<span class="${this.styleSelector}__heatmap ${this.styleSelector}__heatmap--decrease"><w-icon type="caret-down-filled"></w-icon> ${wealthify.type.number.toCurrency(this.currentProjectionData[key] - data[key], false)}</span>`;
            }

            heatmapData[key] = heatmapValue;
        });

        return heatmapData;
    }

    _updateGauge() {
        this.dom.gauge.value = this.currentProjectionData['annualincome'];
        this.dom.gauge.setAttribute('threshold-lower', this.dom.gauge.max * 0.5);
        this.dom.gauge.setAttribute('threshold-upper', this.dom.gauge.max * 0.75);

        const percentage = parseFloat((this.currentProjectionData['annualincome'] / this.dom.gauge.max) * 100).toFixed(2);

        this.dom.gauge.titleprop = this.type === 'pensionprojection' ? `This could give you <b>${percentage}%</b> of your desired retirement income` : '';
    }

    _updateState() {
        if (this.animation) {
            return;
        }

        this.dom.content.style.overflow = 'hidden';
        this.dom.content.style.visibility = this.open ? 'hidden' : '';
        this._showgauge();

        this.openHeight = this.dom.projection.offsetHeight + parseInt(getComputedStyle(this.dom.projection).marginBottom);

        const startHeight = this.open ? `${this.openHeight}px` : '0px';
        const endHeight = this.open ? '0px' : `${this.openHeight}px`;

        this.animation = this.dom.content.animate({height: [startHeight, endHeight]}, {
            duration: this.transitionDuration,
            easing: this.transitionEasing
        });

        this.open = !this.open;

        if (!this.open) {
            this.opencard = false;
        }

        this._updateButtons();
        
        this.animation.onfinish = () => {
            this.animation = null;
            this.dom.content.style.visibility = this.open ? '' : 'hidden';
            this.dom.content.style.height = this.open ? 'min-content' : '0px';
            this._showgauge();
        };
    }

    _updateButtons() {
        const submitClassListAction = this.open ? 'remove' : 'add';
        const undoClassListAction = this.open ? 'add' : 'remove';

        this.dom.submitbutton.classList[submitClassListAction]('u-display__none');
        this.dom.undobutton.classList[undoClassListAction]('u-display__none');
    }

    _showgauge() {
        const classListAction = (this.open && this.showgauge) ? 'remove' : 'add';

        this.dom.gauge.classList[classListAction]('u-display__none');
    }
});